import React from 'react'
import { useRecoilValue } from 'recoil'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'

import {
  Grid,
  GridCell,
  Flex,
  Text,
  TEXT_VARIANT_BOLD,
  TEXT_VARIANT_LIGHT,
  TEXT_VARIANT_ITALIC_LIGHT,
  Panel,
  SpacingVertical,
  SPACING_4
} from 'mailup-web-components'

import { pageState } from 'Pages/QuickSend/recoil/state/state'

const BoxInfo = () => {
  const intl = useIntl()
  const { id: idMessage } = useParams()

  const { subject, notes, preHeader } = useRecoilValue(pageState)

  return (
    <Panel>
      <Grid cols={12}>
        <GridCell span={6}>
          <Text variant={TEXT_VARIANT_BOLD}>
            {intl.formatMessage({ id: 'Load.MailupCommon.Message' })}
          </Text>
          <SpacingVertical variant={SPACING_4} />
          <Text>{subject}</Text>
          <Flex columnGap='4px'>
            <Text variant={TEXT_VARIANT_LIGHT}>{`${idMessage} ${notes &&
              '- ' + notes}`}</Text>
          </Flex>
        </GridCell>
        <GridCell span={6}>
          <Text variant={TEXT_VARIANT_BOLD}>
            {intl.formatMessage({
              id: 'Load.SavedEmailWizard.PreheaderLabel'
            })}
          </Text>
          <SpacingVertical variant={SPACING_4} />
          <Text variant={TEXT_VARIANT_ITALIC_LIGHT}>
            {preHeader ||
              intl.formatMessage({ id: 'Load.QuickSend.NoPreheaderFound' })}
          </Text>
        </GridCell>
      </Grid>
    </Panel>
  )
}

export default BoxInfo
